import { Outlet } from '@remix-run/react';

import type { APHandle, HandleHideNavigation } from '@modules/root';

/**
 * Layout for the B2B routes (`/b2b`, `/b2b/brands`, `/b2b/professionals`).
 *
 * The fallback launch plan is a redirect from `business.archiproamerica.com`
 * to `archiproamerica.com/b2b/*`, with the edge proxy rewrite plan still on
 * the table. Both shapes work without a host gate at the origin, so the
 * `isBusinessSubdomain` redirect has been disabled for now to keep the
 * pages reachable from any host. Re-enable by restoring a loader that
 * calls `isBusinessSubdomain(request)` from `~/utils/request.server` —
 * the helper is still exported.
 *
 * The shared nav / footer / search / chat box are hidden across every B2B
 * route via the `handle` export (the B2B template renders its own dedicated
 * transparent nav + footer).
 */

const hideOnAllDevices: HandleHideNavigation = {
    desktop: true,
    tablet: true,
    mobile: true,
};

export const handle: APHandle = {
    hideTopNavigation: hideOnAllDevices,
    hideFooter: hideOnAllDevices,
    disableSearch: true,
    isChatBoxesDisabled: true,
    // Strip the default mobile `padding-top: 74px` on `#app-page-content` —
    // that gap exists to clear the global mobile top nav, which we hide on
    // every B2B route. Same override pattern proposal routes use.
    contentClassName: '!pt-0',
};

export default function B2BLayout() {
    return <Outlet />;
}
